import ProvisionalReceiptConfig from './ProvisionalReceiptConfig';

export default ProvisionalReceiptConfig;
